module.exports = __webpack_public_path__ + "img/clip.ca7a4af1.svg";